import * as React from 'react';
import './legal-terms-container.scss';
import { ContentfulLegalTermsContainer, ContentfulStandardTerm } from '../../../interfaces';
import StandardTerm from '../standard-term/standard-term';
import { RichTextRenderer } from '../shared/rich-text-renderer'; 
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { withContentfulLivePreviewSys } from '../../../utils/with-contentful-live-preview-sys';

export default function LegalTermsContainer(props: ContentfulLegalTermsContainer) {
  const liveData = useContentfulLiveUpdates(withContentfulLivePreviewSys(props));

  const { 
    contentful_id,
    title,
    subtitle,
    categoryTitle,
    legalItems,
  } = liveData;

  const inspector = useContentfulInspectorMode(
    contentful_id ? { entryId: contentful_id } : undefined
  );


  const titleInspector = inspector({ fieldId: 'text', entryId: title?.contentful_id });
  const subtitleInspector =  inspector({ fieldId: 'text', entryId: subtitle?.contentful_id });
  const categoryInspector = inspector({ fieldId: 'text', entryId: categoryTitle?.contentful_id });

  const pageTitle = title?.text || '';
  const pageSubtitle = subtitle?.text?.raw ?? subtitle?.text?.json;
  const titleCategory = categoryTitle?.text || '';


  if (!legalItems || legalItems.length === 0) return null;

  return (
    <div className="legal-terms-container">
      {pageTitle &&
        <h2 className='legal-terms-container__title' {...titleInspector}>{pageTitle}</h2>
      }

      {pageSubtitle && (
        <div className="legal-terms-container__subtitle" {...subtitleInspector} >
          <RichTextRenderer raw={pageSubtitle} />
        </div>
      )}

      <div className="legal-terms-container__section">
        {titleCategory && <h2 className='legal-terms-container__category' {...categoryInspector} >{titleCategory}</h2>}

        <div className='legal-terms-container__list'>
          {legalItems.map((item, index) => {
            if (!item) return null;

            return (
              <StandardTerm
                key={`term-${index}`}
                {...item as ContentfulStandardTerm}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}